import { UserClientSettingsItem } from "../config/config-item-model";

export class AuthenticateRequestModel {
  userName?: string;
  password?: string;
}

export class RefreshTokenModel {
    refreshToken?: string;

    constructor(refreshToken?: string) {
        this.refreshToken = refreshToken;
    }
}


export class AuthenticateResponseModel {
    success: boolean = false;
    employeeId: number = 0;
    customerId: number = 0;
    userId: number = 0;
    distributorName?: string;
    distributorId?: number;
    firstName?: string;
    lastName?: string;
    username?: string;
    postfix?: string;
    rights?: string;
    roleId?: number;
    role?: string;
    jwtToken?: string;
    refreshToken?: string;
    theme?: string;
    userClientSettings: UserClientSettingsItem[] = [];
}


